export const ALERT_SEVERITY_INFO = 'info'
export const ALERT_SEVERITY_SUCCESS = 'success'
export const ALERT_SEVERITY_WARNING = 'warning'
export const ALERT_SEVERITY_ERROR = 'error'

export const ALERT_CONNECT_STORE = 'connect_store'
